import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { isLoginError, loginWithSession } from 'shared/api/sessionAuth';

import Layout from 'layouts/supporter/Layout';

import logo from 'assets/common/icons/logo_m.png';

const Login: React.FC = () => {
  const { t } = useTranslation();
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!loginId || !password) {
      setError(t('messages.errors.requiredLogin'));
      return;
    }
    try {
      const result = await loginWithSession(loginId, password, 'supporter');
      if (isLoginError(result)) {
        setError(t('messages.errors.invalidLogin'));
        return;
      }
      window.location.href = '/supporter';
    } catch {
      setError(t('messages.errors.networkError'));
    }
  };

  return (
    <Layout>
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="flex flex-col items-center w-full max-w-md px-8 py-10 bg-white shadow-xl rounded-2xl">
          <img src={logo} alt="Goodrescue24" className="h-24 mb-4" />
          <h1 className="text-base font-semibold tracking-wide text-center text-gray-500 mb-7">協力パートナー<br />ログイン</h1>
          <form className="w-full" onSubmit={handleSubmit}>
            {error && (
              <div className="mb-4 text-sm text-center text-red-600">{error}</div>
            )}
            <div className="mb-5">
              <label className="block mb-2 text-gray-600" htmlFor="loginId">
                ログインID (メールアドレス)
              </label>
              <input
                id="loginId"
                type="text"
                value={loginId}
                onChange={e => setLoginId(e.target.value)}
                className="w-full px-4 py-2 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                autoComplete="username"
              />
            </div>
            <div className="mb-7">
              <label className="block mb-2 text-gray-600" htmlFor="password">
                パスワード
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                className="w-full px-4 py-2 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                autoComplete="current-password"
              />
            </div>
            <button
              type="submit"
              className="w-full py-3 mb-3 rounded-lg bg-primary text-white font-semibold text-base shadow hover:bg-[#001d44] transition-colors duration-150"
            >
              ログイン
            </button>
            <button
              type="button"
              className="w-full py-3 mb-3 font-semibold text-gray-900 transition bg-white border border-gray-300 rounded-lg shadow hover:bg-gray-100 active:shadow-inner"
              style={{ boxShadow: '0 2px 6px 0 rgba(0,0,0,0.08)' }}
            >
              新規登録
            </button>
            <div className="text-center">
              <a href="#" className="text-sm text-blue-600 hover:underline">
                ログインにお困りの方はこちら
              </a>
            </div>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default Login;
